module.exports = __webpack_public_path__ + "img/diagnosis.b22d32f4.svg";